import { Link } from "react-router-dom";
import { ChevronRight, Home } from "lucide-react";

/**
 * A clickable path trail (Home / Category / Product) instead of a plain
 * "Back" label — shows the user exactly where they are in the catalog
 * hierarchy and lets them jump to any level, not just one step back.
 * `items` is the trail after Home; the last item is the current page
 * (rendered as plain text, not a link) unless it also carries a `to`.
 */
export default function Breadcrumbs({ items, className = "" }) {
  return (
    <nav
      aria-label="Breadcrumb"
      className={`flex items-center gap-1 overflow-x-auto whitespace-nowrap text-xs text-ink-light ${className}`}
    >
      <Link to="/" className="flex shrink-0 items-center hover:text-ink" aria-label="Home">
        <Home size={13} />
      </Link>
      {items.map((item, i) => {
        const isLast = i === items.length - 1;
        return (
          <span key={i} className="flex shrink-0 items-center gap-1">
            <ChevronRight size={12} className="text-mono/20" />
            {item.to && !isLast ? (
              <Link to={item.to} className="hover:text-ink">
                {item.label}
              </Link>
            ) : (
              <span className="max-w-[45vw] truncate text-ink lg:max-w-xs">{item.label}</span>
            )}
          </span>
        );
      })}
    </nav>
  );
}
